import React from 'react';
import Input from '../../../components/ui/Input';

const ConfigurationPanel = ({ config, onConfigChange }) => {
  const handleChange = (field, value) => {
    const numValue = parseFloat(value) || 0;
    onConfigChange({ ...config, [field]: numValue });
  };

  return (
    <div className="space-y-4">
      <h3 className="text-sm font-semibold text-foreground">Commercial Configuration</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="space-y-2">
          <Input
            label="Overhead (%)"
            type="number"
            value={config?.overhead}
            onChange={(e) => handleChange('overhead', e?.target?.value)}
            min="0"
            max="100"
            step="0.1"
            required
          />
          <input
            type="range"
            min="0"
            max="50"
            step="0.5"
            value={config?.overhead}
            onChange={(e) => handleChange('overhead', e?.target?.value)}
            className="w-full h-2 bg-muted rounded-lg appearance-none cursor-pointer accent-primary"
          />
        </div>

        <div className="space-y-2">
          <Input
            label="Target Margin (%)"
            type="number"
            value={config?.targetMargin}
            onChange={(e) => handleChange('targetMargin', e?.target?.value)}
            min="0"
            step="0.1"
            required
          />
          <input
            type="range"
            min="0"
            max="50"
            step="0.5"
            value={config?.targetMargin}
            onChange={(e) => handleChange('targetMargin', e?.target?.value)}
            className="w-full h-2 bg-muted rounded-lg appearance-none cursor-pointer accent-primary"
          />
        </div>

        <div className="space-y-2">
          <Input
            label="Contingency (%)"
            type="number"
            value={config?.contingency}
            onChange={(e) => handleChange('contingency', e?.target?.value)}
            min="0"
            max="100"
            step="0.1"
            required
          />
          <input
            type="range"
            min="0"
            max="30"
            step="0.5"
            value={config?.contingency}
            onChange={(e) => handleChange('contingency', e?.target?.value)}
            className="w-full h-2 bg-muted rounded-lg appearance-none cursor-pointer accent-primary"
          />
        </div>
      </div>
      <div className="p-3 bg-primary/5 border border-primary/20 rounded-lg">
        <div className="text-xs text-muted-foreground mb-2">Quick Presets</div>
        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => onConfigChange({ overhead: 15, targetMargin: 20, contingency: 5 })}
            className="px-3 py-1 text-xs font-medium bg-card border border-border rounded-md hover:bg-muted transition-smooth"
          >
            Conservative (15/20/5)
          </button>
          <button
            onClick={() => onConfigChange({ overhead: 12, targetMargin: 25, contingency: 8 })}
            className="px-3 py-1 text-xs font-medium bg-card border border-border rounded-md hover:bg-muted transition-smooth"
          >
            Standard (12/25/8)
          </button>
          <button
            onClick={() => onConfigChange({ overhead: 10, targetMargin: 30, contingency: 10 })}
            className="px-3 py-1 text-xs font-medium bg-card border border-border rounded-md hover:bg-muted transition-smooth"
          >
            Aggressive (10/30/10)
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfigurationPanel;